// Theme: forest-console
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'forest-console',
  name: 'FOREST CONSOLE',
  tagline: 'FOREST CONSOLE',
  description: 'Interface de floresta profunda com verde tecnico organico.',
  category: 'organic-world',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#0F1A10', '#1A2A1A', '#22C55E', '#F0FDF4'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-forest-console'
  },
  colorVars: {
    '--accent': '#22C55E',
    '--accent-foreground': '#0F1A10',
    '--background': '#0F1A10',
    '--border': '#3A7A4A',
    '--card': '#1A2A1A',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F0FDF4',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F1A10',
    '--foreground': '#F0FDF4',
    '--hold-fill': '#22C55E',
    '--input': '#3A7A4A',
    '--modal-bg': '#0F1A10',
    '--modal-border': '#3A7A4A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#3A7A4A',
    '--muted-foreground': '#F0FDF4',
    '--nav-active': '#22C55E',
    '--nav-bg': '#1A2A1A',
    '--popover': '#1A2A1A',
    '--popover-foreground': '#F0FDF4',
    '--primary': '#22C55E',
    '--primary-foreground': '#0F1A10',
    '--ring': '#22C55E',
    '--secondary': '#3A7A4A',
    '--secondary-foreground': '#F0FDF4',
    '--streak': '#22C55E',
    '--success': '#22c55e',
    '--success-foreground': '#0F1A10',
    '--xp': '#22C55E',
    '--xp-bg': '#1A2A1A'
  },
  resolvedVars: {
    '--accent': '#22C55E',
    '--accent-foreground': '#0F1A10',
    '--accent-foreground-hsl': '125 27% 8%',
    '--accent-foreground-oklch': 'from #0F1A10 l c h',
    '--accent-hsl': '142 71% 45%',
    '--accent-oklch': 'from #22C55E l c h',
    '--background': '#0F1A10',
    '--background-hsl': '125 27% 8%',
    '--background-oklch': 'from #0F1A10 l c h',
    '--border': '#3A7A4A',
    '--border-hsl': '135 36% 35%',
    '--border-oklch': 'from #3A7A4A l c h',
    '--border-w': '1px',
    '--card': '#1A2A1A',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F0FDF4',
    '--card-foreground-hsl': '138 76% 97%',
    '--card-foreground-oklch': 'from #F0FDF4 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--card-hsl': '120 24% 13%',
    '--card-oklch': 'from #1A2A1A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F1A10',
    '--destructive-foreground-hsl': '125 27% 8%',
    '--destructive-foreground-oklch': 'from #0F1A10 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F0FDF4',
    '--foreground-hsl': '138 76% 97%',
    '--foreground-oklch': 'from #F0FDF4 l c h',
    '--hold-fill': '#22C55E',
    '--hold-fill-hsl': '142 71% 45%',
    '--hold-fill-oklch': 'from #22C55E l c h',
    '--input': '#3A7A4A',
    '--input-hsl': '135 36% 35%',
    '--input-oklch': 'from #3A7A4A l c h',
    '--modal-bg': '#0F1A10',
    '--modal-bg-hsl': '125 27% 8%',
    '--modal-bg-oklch': 'from #0F1A10 l c h',
    '--modal-border': '#3A7A4A',
    '--modal-border-hsl': '135 36% 35%',
    '--modal-border-oklch': 'from #3A7A4A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#3A7A4A',
    '--muted-foreground': '#F0FDF4',
    '--muted-foreground-hsl': '138 76% 97%',
    '--muted-foreground-oklch': 'from #F0FDF4 l c h',
    '--muted-hsl': '135 36% 35%',
    '--muted-oklch': 'from #3A7A4A l c h',
    '--nav-active': '#22C55E',
    '--nav-active-hsl': '142 71% 45%',
    '--nav-active-oklch': 'from #22C55E l c h',
    '--nav-bg': '#1A2A1A',
    '--nav-bg-hsl': '120 24% 13%',
    '--nav-bg-oklch': 'from #1A2A1A l c h',
    '--popover': '#1A2A1A',
    '--popover-foreground': '#F0FDF4',
    '--popover-foreground-hsl': '138 76% 97%',
    '--popover-foreground-oklch': 'from #F0FDF4 l c h',
    '--popover-hsl': '120 24% 13%',
    '--popover-oklch': 'from #1A2A1A l c h',
    '--primary': '#22C55E',
    '--primary-foreground': '#0F1A10',
    '--primary-foreground-hsl': '125 27% 8%',
    '--primary-foreground-oklch': 'from #0F1A10 l c h',
    '--primary-hsl': '142 71% 45%',
    '--primary-oklch': 'from #22C55E l c h',
    '--radius': '10px',
    '--ring': '#22C55E',
    '--ring-hsl': '142 71% 45%',
    '--ring-oklch': 'from #22C55E l c h',
    '--secondary': '#3A7A4A',
    '--secondary-foreground': '#F0FDF4',
    '--secondary-foreground-hsl': '138 76% 97%',
    '--secondary-foreground-oklch': 'from #F0FDF4 l c h',
    '--secondary-hsl': '135 36% 35%',
    '--secondary-oklch': 'from #3A7A4A l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#22C55E',
    '--streak-hsl': '142 71% 45%',
    '--streak-oklch': 'from #22C55E l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0F1A10',
    '--success-foreground-hsl': '125 27% 8%',
    '--success-foreground-oklch': 'from #0F1A10 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(142 71% 45% / 0.15)',
    '--xp': '#22C55E',
    '--xp-bg': '#1A2A1A',
    '--xp-bg-hsl': '120 24% 13%',
    '--xp-bg-oklch': 'from #1A2A1A l c h',
    '--xp-hsl': '142 71% 45%',
    '--xp-oklch': 'from #22C55E l c h'
  }
}
